<template>
    <swiper :options="swiperOption" v-if="features.length" class="news-internal">
        <swiper-slide v-for="(feature,index) in features" :key="index">
            <features-slide-element :feature="feature"></features-slide-element>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev">
            <svg version="1.1" id="Chevron_thin_left" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
                     y="0px" viewBox="0 0 20 20" enable-background="new 0 0 20 20" xml:space="preserve">
                <path fill="#FFFFFF" d="M13.891,17.418c0.268,0.272,0.268,0.709,0,0.979s-0.701,0.271-0.969,0l-7.83-7.908
                    c-0.268-0.27-0.268-0.707,0-0.979l7.83-7.908c0.268-0.27,0.701-0.27,0.969,0c0.268,0.271,0.268,0.709,0,0.979L6.75,10L13.891,17.418
                    z"/>
                </svg>
        </div>
        <div class="swiper-button-next" slot="button-next">
            <svg version="1.1" id="Chevron_thin_right" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
                     y="0px" viewBox="0 0 20 20" enable-background="new 0 0 20 20" xml:space="preserve">
                <path fill="#FFFFFF" d="M13.25,10L6.109,2.58c-0.268-0.27-0.268-0.707,0-0.979c0.268-0.27,0.701-0.27,0.969,0l7.83,7.908
                    c0.268,0.271,0.268,0.709,0,0.979l-7.83,7.908c-0.268,0.271-0.701,0.27-0.969,0c-0.268-0.269-0.268-0.707,0-0.979L13.25,10z"/>
                </svg>
        </div>
    </swiper>
</template>

<script>
	import FeaturesSlideElement from "./features-slide-element.vue";
	import {swiper, swiperSlide} from 'vue-awesome-swiper';
	export default {
		props: [
			"features"
		],
		components: {
			FeaturesSlideElement,
			swiper,
			swiperSlide,
		},
		data () {
			return {
				swiperOption: {
					slidesPerView: 4,
					breakpoints: {
						1024: {
							slidesPerView: 2
						},
						480: {
							slidesPerView: 1
						}
					},
					paginationClickable: true,
					autoplay: 10000,
					autoplayDisableOnInteraction: true,
					pagination: '.news-internal .swiper-pagination',
					nextButton: '.news-internal .swiper-button-next',
					prevButton: '.news-internal .swiper-button-prev',
					// Enable lazy loading
					lazyLoading: true,
				}
			}
		}
	}
</script>

<style lang="scss">
    @import "../news/slide";
</style>


// WEBPACK FOOTER //
// features-slide.vue?39877ac2